jQuery(document).ready(function($){
	const product_cards = document.querySelectorAll('.product-grid_product');
	let reset = null;
	for ( const product_card of product_cards ) {
		const popover = product_card.querySelector('.product-grid_popover');
		const view_more = product_card.querySelector('.product-grid_product-view-more');
		if ( ! popover || ! view_more ) continue
		popover.addEventListener("toggle", (event) => {
			if(event.newState === "open") {
				popover.classList.add( '--open' );
				reset = inertAllBut(popover)
			} else {
				popover.classList.remove( '--open' );
				reset?.()
			}
			popover.querySelector('button').focus({preventScroll: true, focusVisisble: true})
		} );
	}
} );

export const inertAllBut = (element) => {
  const parent = element.parentElement;
  if (!parent) return () => {};
  const siblings = [...parent.children].filter((el) => el !== element);
  siblings.forEach((el) => ((el).inert = true));
  const resetSiblings = () => {
    siblings.forEach((el) => ((el).inert = false));
  };
  const resetAncestors = inertAllBut(parent);
  const resetAll = () => {
    resetAncestors();
    resetSiblings();
  };
  return resetAll;
};